export default __webpack_public_path__ + "static/media/img6.12d0adfc.svg";